export default __webpack_public_path__ + "images/JI.904b938.png";